import { translationConstants } from "./translation.constants";
import MASTER_CARD_ICON from "../assets/images/icon/MASTER_ICON.svg";
import VISA_CARD_ICON from "../assets/images/icon/VISA_ICON.svg";
import MADA_CARD_ICON from "../assets/images/icon/MADA_ICON.svg";

export const paymentConstants = {
  CHECKOUT_ID: "CHECKOUT_ID",
  CHECKOUT_ID_NULL: "CHECKOUT_ID_NULL",
  PAYMENT_HISTORY: "PAYMENT_HISTORY",
  PAYMENT_HISTORY_FREELANCER: "PAYMENT_HISTORY_FREELANCER",
  PAYMENT_HISTORY_STATS: "PAYMENT_HISTORY_STATS",
  ADMIN_PAYMENT_HISTORY: "ADMIN_PAYMENT_HISTORY",
  SAVED_PAYMENT_CARDS: "SAVED_PAYMENT_CARDS",
  SPINNER: "SPINNER",
  CARD_NUMBER_MASK: "xxxx xxxx xxxx ",
  DATE_SELECTION_LENGTH: 2,
  CHECKOUT_ID_SAVED_CARD: "CHECKOUT_ID_SAVED_CARD",
};

export const paymentFormDivIds = {
  newCardForm: "newCardForm",
  savedCardForm: "savedCardForm",
  addCardForm: "addCardForm",
};

export const paymentType = {
  Membership: 0,
  Event: 1,
  Competition: 2,
  Center: 3,
  Freelance: 4,
  Addon: 5,
  SaveCard: 6,
};

export const paymentTypeConstants = {
  0: "SSF_PAYMENT_MEMBERSHIP",
  1: "SSF_PAYMENT_EVENT_REGISTRATION",
  2: "SSF_PAYMENT_COMPETITION_REGISTRATION",
  3: "SSF_PAYMENT_CENTER",
  4: "SSF_PAYMENT_FREELANCE",
  5: "SSF_PAYMENT_ADDON",
};

export const addonTypeConstants = {
  0: "SSF_PAYMENT_CENTER_SPOT_ADDON",
  1: "SSF_PAYMENT_CENTER_SPOT_SPORT_ADDON",
  2: "SSF_PAYMENT_FREELANCE_SPORT_ADDON",
};

export const allowedPaymentCards = "MASTER VISA MADA";

export const paymentCardType = {
  MASTER: "MASTER",
  VISA: "VISA",
  AMEX: "AMEX",
  DISCOVER: "DISCOVER",
  JCB: "JCB",
  MADA: "MADA",
};

export const paymentCardIcon = {
  MASTER: MASTER_CARD_ICON,
  VISA: VISA_CARD_ICON,
  AMEX: "AMEX",
  DISCOVER: "DISCOVER",
  JCB: "JCB",
  MADA: MADA_CARD_ICON,
};

export const paymentCardRadioButtonConstants = {
  SAVEDCARDS: "0",
  NEWCARD: "1",
};

export const addonType = {
  CenterSpot: 0,
  CenterSpotSport: 1,
  FreelanceSport: 2,
};

export const paymentPriceTypeConstants = {
  Registration: 0,
  SpecialMember: 1,
};
